import dayjs, { Dayjs } from "dayjs";
import { useSelectedDate } from "../../shared/hooks/use-selected-date";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useYearEvents } from "../../shared/data-access/calendar-data.provider";
import { useDateYearEvents } from "../../shared/hooks/use-date-year-events";
import { StyledYearEvent, StyledHeader, StyledContent, StyledContentElem, StyledButton } from "./year-events.style";
import { Row } from "antd";

const YearEvent = () => {
    const navigate = useNavigate();

    const selectedDate: Dayjs = useSelectedDate();

    const [selectedYear, setSelectedYear] = useState<number>(dayjs().year());

    const selectedYearEvents = useDateYearEvents();

    useEffect(() => {
        const year: number = selectedDate.year();
        setSelectedYear(year)
    }, [selectedDate])

    useEffect(() => {
    }, [selectedYearEvents]);

    return (
        <StyledYearEvent>
            <StyledHeader>У {selectedYear} годзе спаўняецца...</StyledHeader>

            <StyledContent>
                {selectedYearEvents.map(({ name, date }) => {
                    const contentElemText: string =
                        `${selectedDate.year() - dayjs(date).year()} гадоў ` + name;
                    return (
                        <StyledContentElem isCursorPointer={false}>
                            {contentElemText}
                        </StyledContentElem>
                    );
                })}


            </StyledContent>
            <StyledButton
                onClick={() =>
                    navigate(
                        selectedDate ? `/?date=${JSON.stringify(selectedDate)}` : "/",
                        {
                            replace: true,
                        }
                    )
                }
            >
                &#8592; Назад
            </StyledButton>

        </StyledYearEvent>
    )
}

export default YearEvent;